import {Section} from "../grouping/Section";
import {SelectionList} from "../SelectionList";
import {CustomEditor} from "../CustomEditor";
import {ListItemButton} from "../ListItemButton";
import {Button, Col, Form, FormGroup, FormLabel, Row} from "react-bootstrap";
import {ModalPopUp} from "../grouping/ModalPopUp";
import {useCallback, useState} from "react";
import {useForm} from "../../utilities/formutilities";
import {ARTICLE_EMPTY, useArticleMutations, useArticles} from "../../api/articleapi";
import {ModalContentContainer} from "../grouping/ModalContentContainer";
import {ButtonLoading} from "../ButtonLoading";
import {FaEye} from "react-icons/fa";
import {IoMdEyeOff} from "react-icons/io";

import Collapse from "react-bootstrap/Collapse";
import {ConfirmToast} from "../ConfirmToast";
import {FILE_EMPTY, useFileMutations} from "../../api/fileapi";

export function ArticleOption(props) {
    const [open, setOpen] = useState(false);
    const {articles} = useArticles();
    const {title} = props;
    const [editingArticle, setEditingArticle] = useState();
    return <Section title={title}>
        <Col xs={12} className={"text-end"}><Button onClick={() => setOpen(true)}>Nieuw artikel</Button></Col>
        <ModalPopUp open={open} onOpenChanged={setOpen}
                    modalContent={<ContentForModal title={editingArticle ? "Wijzig artikel" : "Nieuw artikel"}
                                                   editingArticle={editingArticle}
                                                   onEditingArticleChanged={setEditingArticle}
                                                   onOpenChanged={setOpen}/>}/>
        <SelectionList>
            {articles?.sort((a1, a2) => new Date(a2.timeCreated) - new Date(a1.timeCreated))?.map(a => <ListItemArticle
                key={a.id} article={a} onOpenChanged={setOpen}
                onEditingArticleChanged={setEditingArticle}
                title={a.title}/>)}
        </SelectionList>
    </Section>
}


function ListItemArticle(props) {
    const {article, onOpenChanged, onEditingArticleChanged} = props;
    const [open, setOpen] = useState();
    return <Row className={"g-0 border border-black rounded-2 mt-2"}>
        <Col>
            <ListItemButton onClick={() => {
                onEditingArticleChanged(article);
                onOpenChanged(true);
            }}>
                <Col className={"text-start"}>
                    <Text title={article.title}/>
                </Col>
                <Col xs={"auto"} className={"ms-2 me-2 text-start"}>
                    <Text title={article.timeCreated.substring(0, 10)}/>
                </Col>
            </ListItemButton>
        </Col>
        <Col xs={"auto"} className={"text-end"}>
            <Button onClick={e => {
                e.stopPropagation();
                setOpen(!open)
            }} className={"btn-light h-100"}>{open ? <IoMdEyeOff/> : <FaEye/>}</Button>

        </Col>
        <Col xs={12}>
            <Collapse in={open}>
                <div className={"mt-3 border border-black rounded-2 p-2 m-2"}
                     dangerouslySetInnerHTML={{__html: article?.description.split('<hr>')[0]}}>

                </div>
            </Collapse>
        </Col>
    </Row>
}

function Text(props) {
    const {title} = props;

    return <p className={"p-0 m-0 g-0"}>{title}</p>
}

function ContentForModal(props) {
    const [isLoading, setIsLoading] = useState(false);
    const {title, editingArticle, onOpenChanged, onEditingArticleChanged} = props;
    const {uploadFile} = useFileMutations();
    const initialFileObjectInitializer = useCallback(() => FILE_EMPTY);
    const {onFileInputChange, tempFileObject} = useForm(initialFileObjectInitializer)
    const initialObjectInitializer = useCallback(() => editingArticle ? {
        ...editingArticle,
        timeCreated: editingArticle?.timeCreated ? editingArticle.timeCreated.substring(0, 10) : new Date().toISOString().substring(0, 10)
    } : {
        ...ARTICLE_EMPTY,
        timeCreated: new Date().toISOString().substring(0, 10)
    }, []);
    const {tempObject, onChange, onEditorChange} = useForm(initialObjectInitializer);
    const {createArticle, editArticle, deleteArticle} = useArticleMutations();

    async function handleCreateSubmit(e) {
        e.preventDefault();
        const uploadFileResult = tempFileObject.file ? await uploadFile({file: tempFileObject.file}) : undefined;
        const savedObj = await createArticle({
            ...tempObject,
            timeCreated: tempObject.timeCreated + "T00:00:00",
            filesarticles: uploadFileResult ? [uploadFileResult.id] : []
        });
        if (savedObj)
            onOpenChanged(false);
        onEditingArticleChanged(undefined);
        setIsLoading(false)
    }

    async function handleEditSubmit(e) {
        e.preventDefault();
        const uploadFileResult = tempFileObject.file ? await uploadFile({file: tempFileObject.file}) : undefined;

        const savedObj = await editArticle({
            ...tempObject,
            timeCreated: tempObject.timeCreated + "T00:00:00",
            filesarticles: uploadFileResult ? [uploadFileResult.id] : tempObject.filesarticles
        });
        if (savedObj)
            setIsLoading(false)


    }

    return <ModalContentContainer onEditingChanged={onEditingArticleChanged}
                                  onOpenChanged={onOpenChanged}>
        <Form>
            <Section title={title}>
                <Col xs={12}>
                    <FormGroup>
                        <FormLabel>{"Titel"}</FormLabel>
                        <Form.Control value={tempObject.title}
                                      onChange={event => onChange(event, "title")}/>
                        <FormLabel>{"Datum"}</FormLabel>
                        <Form.Control type={"date"}
                                      value={tempObject.timeCreated ? tempObject.timeCreated : new Date().toISOString().substring(0, 10)}
                                      onChange={event => onChange(event, "timeCreated")}/>
                    </FormGroup>
                </Col>
                <Col xs={12}>
                    <FormGroup>
                        <FormLabel>{editingArticle ? "Wijzig Bijlage" : "Bijlage"}</FormLabel>
                        <Form.Control type={'file'}
                                      onChange={event => {
                                          onFileInputChange(event, "file");
                                      }}/>


                    </FormGroup>
                </Col>
                <Col className={"mt-2"} xs={12}>
                    <FormGroup>
                        <Form.Label>{"Inhoud"}</Form.Label>
                        <CustomEditor initText={editingArticle ? editingArticle.description : ""}
                                      fieldName={"description"}
                                      onEditorChange={onEditorChange}/>
                    </FormGroup>

                </Col>
                {editingArticle
                    ?
                    <Col xs={6}>
                        <ConfirmToast message={"Ben je zeker dat je dit artikel wilt verwijderen?"}
                                      className={"btn-danger mt-3"}
                                      title={"Delete"}
                                      executeFunction={async () => {
                                          const message = await deleteArticle(editingArticle);
                                          if (message)
                                              onOpenChanged(false);
                                          onEditingArticleChanged(undefined);
                                      }}/>

                    </Col>
                    :
                    ""
                }
                <Col xs={editingArticle ? 6 : 12} className={"text-end mt-3"}>
                    <ButtonLoading title={"Opslaan"} isLoading={isLoading} onClick={(e) => {
                        setIsLoading(true);
                        editingArticle ? handleEditSubmit(e) : handleCreateSubmit(e)
                    }}/>
                </Col>
            </Section>
        </Form>
    </ModalContentContainer>
}

